import { DictType } from "@pma/types"
import Autoplay from "embla-carousel-autoplay"
import { Card, CardContent, CardHeader, CardTitle } from "@components/common/card"
import useTranslator from "@hooks/use-translator"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@components/common/carousel"
import { Files, Pin } from "lucide-react"
import { cn } from "@pma/utils/helpers"
import { Fragment, useContext, useEffect } from "react"
import { ProjectContext } from "@pma/contexts/ProjectContext"
import ProjectCard from "../projects/project-card"
import { Alert, AlertDescription, AlertTitle } from "@components/common/alert"
import { PROJECTS_PAGE_ROUTE } from "@pma/utils/page-routes"
import { Link } from "react-router-dom"
import PmsLoader from "../common/loader"

const PinnedProjects = () => {
  const { translate, locale } = useTranslator()

  const isHebrew = locale === "he"
  const { pinnedProjectResult } = useContext(ProjectContext)

  useEffect(() => {
    pinnedProjectResult?.refetch()
  }, [])

  return (
    <Card className='overflow-hidden shadow-none'>
      <CardHeader className='flex py-4 pb-0'>
        <CardTitle
          className={cn(
            "relative flex h-fit flex-col p-0 text-xl font-semibold",
            isHebrew ? "text-right" : "text-left",
          )}
        >
          <Pin
            size={14}
            className={cn(
              "absolute -top-2",
              isHebrew ? "-right-4 rotate-45" : "-left-4 -rotate-45",
            )}
          />
          {translate("Pinned Projects")}
        </CardTitle>
      </CardHeader>
      {pinnedProjectResult?.isLoading ? (
        <PmsLoader />
      ) : pinnedProjectResult?.data?.items && pinnedProjectResult?.data?.items.length > 0 ? (
        <Carousel
          opts={{
            align: "start",
            loop: true,
            direction: isHebrew ? "rtl" : "ltr",
          }}
          plugins={[Autoplay({ delay: 3000 })]}
          className='w-full p-4'
        >
          <CarouselContent className={cn("w-full", isHebrew ? "pr-4" : "pl-4")}>
            {pinnedProjectResult?.data?.items.map((project: DictType) => (
              <Fragment key={project?.id}>
                <CarouselItem className='sm:basis-1/1 relative w-fit basis-full border border-none p-1 md:basis-1/2 lg:basis-1/3'>
                  <ProjectCard project={project} key={project?.id} />
                </CarouselItem>
              </Fragment>
            ))}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      ) : (
        <CardContent className={cn("p-4 text-right", isHebrew ? "text-right" : "text-left")}>
          <Alert variant='info'>
            <div className="absolute top-6">
              <Files className='h-4 w-4' />
            </div>
            <AlertTitle className={isHebrew ? "pr-7" : "pl-7"}>
              {translate("Your pinned projects will appear here")}!
            </AlertTitle>
            <AlertDescription className={isHebrew ? "pr-7" : "pl-7"}>
              <Link className='hover:underline' to={PROJECTS_PAGE_ROUTE}>
                {translate("Go to your projects to pin any projects")}
              </Link>
            </AlertDescription>
          </Alert>
        </CardContent>
      )}
    </Card>
  )
}

export default PinnedProjects
